import React, { useContext, useEffect, useState } from 'react';
import store from '../../../../redux/store';
import { useNavigate, useParams } from 'react-router-dom';
import { AlertContext, Alert_, Confirmation_, Main_, Main_Plain, Red_, Slider_ } from 'monica-alexandria';
import { Helmet } from 'react-helmet';
import i18n from '../../../../localization/i18next';
import { AuthContext } from '../../../../services/authentication/Guard';
import { checkOwnership } from '../../../../helpers/verifyToolOwnership';
import { useTranslation } from 'react-i18next';
import { Report, ReportContainer, ReportHeader, ReportWrapper } from './REPORT.css';
import { deleteReport, getReport } from '../../services/api/Report';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Report_Upload_Logo from './components/report/Report_Upload_Logo';
import Preview_ from './components/preview/Preview_';
import Report_ from './components/report/Report_';
import Report_Header from './components/report/Report_Header';
import dummyData from '../../data/dummyData.json';

const environment = process.env.REACT_APP_SERVER;


const REPORT = () => {

    const { t } = useTranslation();
    const lang = i18n.language ? i18n.language : 'en';
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const userId = auth?.user?.sub;

    /* id exist in params if we are seeing an old report */
    const { id } = useParams(); 

    /* LocalStorage Data */
    const GoogleSourceData = store.getState().googleSource;
    const managerAccount = GoogleSourceData?.managerAccount;
    const clientAccount = GoogleSourceData?.clientAccount;
    const selectedCampaign = GoogleSourceData?.campaign;
    const selectedDates = GoogleSourceData?.dates;
    const storedReport = GoogleSourceData?.report;

    /* For tool ownership validation */
    const [hasCheckOwnership, setHasCheckOwnership] = useState(false);

    const [report, setReport] = useState();

    /* Alert */
    const { alerts, setAlerts } = useContext(AlertContext);

    const alertMessage = (message, status) => {
        setAlerts([
            ...alerts,
            {
                message: {
                    text: message,
                    status: status,
                },
            },
        ]);
    };


    /* For slider */
    const [activeSlider, setActiveSlider] = useState(false);

    const handleSlider = () => {
        if (activeSlider === 'export') {
            generatePDF();
        } else if (activeSlider === 'upload') {
            setActiveSlider(false);
        }
    }
    
    /* For Confirmation_ */
    const [confirmDlt, toggleConfirmDlt] = useState(false);

    
    /* Switch data assignment ( Real/Dummy ) */
    const initActions = () => {
        const get_report = () => {
            if ( !storedReport?.campaigns && id ) {
                getReport(id)
                .then((response) => {
                    const report = response?.data?.data?.report;
                    if ( report ) {
                        setReport(report);
                    } else alertMessage((t("Something went wrong")),'Error');
                })
                .catch(error=>{
                    console.error(error); 
                    alertMessage((t("Something went wrong")),'Error');
                })
            } else if ( storedReport?.campaigns ) {
                setReport(storedReport);
            } else {
                alertMessage((t("Something went wrong")),'Error');
            }
        }

        if ( environment !== 'LOCAL' ) get_report()
        else setReport(dummyData.getReport.report)
    }



    const generatePDF = () => {
        const input = document.querySelector('#reportPDF');
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/jpeg');
            const imgWidth = 210; // This corresponds to A4 width
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            // Convert dimensions from mm to pt
            let widthInPt = imgWidth * 2.83465;
            let heightInPt = imgHeight * 2.83465;

            // Create a pdf with custom dimensions
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'pt',
                format: [widthInPt, heightInPt],
            });
            pdf.addImage(imgData, 'JPEG', 0, 0, widthInPt, heightInPt);
            pdf.save('report.pdf');
        });
    };


    const delete_report = () => {
        deleteReport(id, userId)
        .then((response) => {
            toggleConfirmDlt(false)
            alertMessage((t('Report deleted successfully...')), 'Success');
            navigate(`/${lang}/google/reports`)
        })
        .catch((error) => {
          alertMessage((t('Error deleting report, Please try again later...')), 'Error');
          toggleConfirmDlt(false)
        });
    }


    useEffect(() => {
        initActions();
    },[])

    /* Validate Tool Ownership */
    useEffect(() => {
        if (userId) checkOwnership(userId, navigate, lang, setHasCheckOwnership);
    }, [userId]);

    console.log('report',report);

  return (
    <>
        <Helmet>
            <title>Adsnap | Report</title>
        </Helmet>
        <Alert_ messages={alerts} />
        {hasCheckOwnership && (
            <Report>
                {activeSlider && (
                    <Slider_ 
                        id={"AdSnap_Google_Report_1"} 
                        title={activeSlider === 'export' ? (t('Preview export')) : (t('Upload logo'))} 
                        text={activeSlider === 'export' ? (t('Export')) : (t('Done'))} 
                        onClick={handleSlider} onClose={() => setActiveSlider(false)} 
                        grey={activeSlider === 'export' ? t('Exit') : ''} 
                        onGrey={() => setActiveSlider(false)}
                    >
                        { activeSlider === 'upload' && <Report_Upload_Logo /> }
                        { activeSlider === 'export' 
                        && ( <ReportContainer id="reportPDF">
                                <Preview_ report={report}/>
                            </ReportContainer>
                        )}
                    </Slider_>
                )}
                {confirmDlt && 
                    <Confirmation_
                        message={t("Are you sure you want to delete your report?")}
                        no={t("No")}
                        onNo={() => toggleConfirmDlt(false)}
                        onYes={delete_report}
                        yes={t("Yes")}
                    />
                }
                <ReportWrapper>
                    <Report_Header 
                        id={id}
                        toggleConfirmDlt={toggleConfirmDlt}
                        setActiveSlider={setActiveSlider}
                    />
                
                    <Report_ report={report} />
                </ReportWrapper>
            </Report>
        )}
    </>
  );
};

export default REPORT;
